import { DashboardLayout } from "components/Dashboard/DashboardLayout";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { Suspense } from "react";
import { FacilityMixTile } from "./FacilityMix/FacilityMixTile";
import { NonComplianceTile } from "./NonCompliance/NonComplianceTile";
import { OverviewContext } from "./OverviewContext";
import {
  ChartTileSkeleton,
  TwoChartTileSkeleton,
} from "components/Dashboard/OverviewSkeleton";
import { PenaltiesTile } from "./Penalties/PenaltiesTile";
import { ViolationsTile } from "./Violations/ViolationsTile";

export function Overview() {
  useBreadcrumb({ label: "Overview" });
  return (
    <DashboardLayout>
      <OverviewContext>
        <Suspense
          fallback={
            <>
              <TwoChartTileSkeleton />
              <ChartTileSkeleton />
              <ChartTileSkeleton />
              <ChartTileSkeleton />
            </>
          }
        >
          <FacilityMixTile />
          <Suspense
            fallback={
              <>
                <ChartTileSkeleton />
                <ChartTileSkeleton />
                <ChartTileSkeleton />
              </>
            }
          >
            <PenaltiesTile />
            <Suspense
              fallback={
                <>
                  <ChartTileSkeleton />
                  <ChartTileSkeleton />
                </>
              }
            >
              <ViolationsTile />
              <Suspense fallback={<ChartTileSkeleton />}>
                <NonComplianceTile />
              </Suspense>
            </Suspense>
          </Suspense>
        </Suspense>
      </OverviewContext>
    </DashboardLayout>
  );
}
